export const bind = ((prototype: object, method: string, descriptor: PropertyDescriptor) => {
    // Запрещаем для статических методов
    if (typeof prototype === 'function') {
        throw new TypeError(`Cannot bind static method ${method}`);
    }

    const func: () => void = descriptor.value;

    // В IE11 при вызове Object.defineProperty есть проблемы при
    // указании getter'а: уходит в бесконечную рекурсию
    let isDefining = false;

    return {
        configurable: true,
        get: function get() {
            if (isDefining) {
                return func;
            }

            const boundFunc: () => void = func.bind(this);

            isDefining = true;

            Object.defineProperty(this, method, {
                configurable: true,
                get: function () {
                    return boundFunc;
                },
            });

            isDefining = false;

            return boundFunc;
        },
    };
}) as MethodDecorator;
